import { render, staticRenderFns } from "./my-editor.vue?vue&type=template&id=59f54c18&scoped=true"
import script from "./my-editor.vue?vue&type=script&lang=js"
export * from "./my-editor.vue?vue&type=script&lang=js"
import style0 from "./my-editor.vue?vue&type=style&index=0&id=59f54c18&prod&lang=scss&scoped=true"
import style1 from "./my-editor.vue?vue&type=style&index=1&id=59f54c18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f54c18",
  null
  
)

export default component.exports